<script setup>
import LegalPage from '@/components/legal/LegalPage.vue'
</script>

<template>
    <Head>
        <title>Cookies</title>
        <meta
            name="description"
            content="Informace o používání cookies na webu solvecount.cz."
        />
    </Head>

    <LegalPage
        title="Cookies"
        updated-at="2026-05-22"
    >
        <p>
            Webové stránky <strong>solvecount.cz</strong> využívají pouze technicky nezbytné cookies, které jsou potřeba
            pro správný chod webu. Žádné analytické ani marketingové cookies nepoužíváme.
        </p>

        <h2>Co jsou cookies</h2>

        <p>
            Cookies jsou malé textové soubory, které prohlížeč ukládá do vašeho zařízení při návštěvě webu. Umožňují
            webu zapamatovat si vaše akce a preference v rámci jedné návštěvy nebo mezi návštěvami.
        </p>

        <h2>Jaké cookies používáme</h2>

        <ul>
            <li>
                <strong>Session cookie</strong> — umožňuje udržet váš stav během procházení webu (např. vyplněný
                kontaktní formulář před odesláním). Vyprší po zavření prohlížeče.
            </li>
            <li><strong>XSRF-TOKEN</strong> — bezpečnostní cookie chránící formulář proti útokům CSRF.</li>
        </ul>

        <p>
            Vzhledem k tomu, že používáme pouze nezbytné cookies pro fungování webu, nepotřebujeme váš souhlas dle
            zákona č. 127/2005 Sb. (§ 89 odst. 3).
        </p>

        <h2>Jak cookies spravovat</h2>

        <p>
            V nastavení svého prohlížeče můžete kdykoliv cookies smazat nebo zablokovat. Pokud nezbytné cookies
            zakážete, některé části webu nemusí fungovat správně.
        </p>

        <ul>
            <li>
                <a
                    href="https://support.google.com/chrome/answer/95647"
                    target="_blank"
                    rel="noopener"
                    >Chrome</a
                >
            </li>
            <li>
                <a
                    href="https://support.mozilla.org/cs/kb/cookies-soubory-vytvarene-webovymi-strankami"
                    target="_blank"
                    rel="noopener"
                    >Firefox</a
                >
            </li>
            <li>
                <a
                    href="https://support.apple.com/cs-cz/guide/safari/sfri11471/mac"
                    target="_blank"
                    rel="noopener"
                    >Safari</a
                >
            </li>
        </ul>

        <p class="mt-12 text-sm text-zinc-500">
            Tento dokument je šablona — pokud začnete používat analytické (Google Analytics, Matomo) nebo marketingové
            cookies, je nutné jej rozšířit a přidat cookie banner se souhlasem.
        </p>
    </LegalPage>
</template>
